export const resolveTemplateString = (templateString: string, dictionary: Record<string, string>) => {
  return templateString.replace(/\{\{.*?\}\}/g, (parameter) => {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const normalizedParameter = parameter.slice(2, -2);
    return dictionary[normalizedParameter] ?? parameter;
  });
};
